export enum FlightsLocation {
  ORIGIN,
  DESTINATION
}
